import { priceHierarchyActionType } from '../../constants';

const priceHierarchyReducer = (state = [], action) => {
    switch (action.type) {
        case priceHierarchyActionType.FETCH_PRICE_HIERARCHY:
            return action.payload;
        case priceHierarchyActionType.FETCH_PRICE_HIERARCHY:
            return action.payload;
        case priceHierarchyActionType.ADD_PRICE_HIERARCHY:
            return action.payload;
        case priceHierarchyActionType.UPDATE_PRICE_HIERARCHY:
            return action.payload;
        case priceHierarchyActionType.DELETE_PRICE_HIERARCHY:
            return action.payload;
        case priceHierarchyActionType.FETCH_BYOD_V2:
            return action.payload;
        default:
            return state;
    }
};
export default priceHierarchyReducer